<template>
  <div class="engineer-container">
    <div class="content-wrapper">
      <!-- 页面标题 -->
      <div style="position: relative;display: inline-block;margin-bottom: 30px;">
        <div class="page-title">认证造价师</div>
        <div class="page-title-line" />
      </div>

      <!-- 选择入口 -->
      <div class="form-section">
        <div class="section-label">选择入口</div>
        <div class="entry-buttons">
          <div
            class="entry-btn"
            :class="{ active: entryType === 1 }"
            @click="selectEntryType(1)"
          >
            个人
          </div>
          <div
            class="entry-btn"
            :class="{ active: entryType === 2 }"
            @click="selectEntryType(2)"
          >
            企业
          </div>
        </div>
      </div>

      <!-- 个人注册表单 -->
      <div
        v-if="entryType === 1"
        class="form-section"
      >
        <div class="section-label">选择分类</div>
        <div class="category-buttons">
          <div
            class="category-btn"
            :class="{ active: categoryType === 1 }"
            @click="selectCategoryType(1)"
          >
            国内/国际
          </div>
          <div
            class="category-btn"
            :class="{ active: categoryType === 2 }"
            @click="selectCategoryType(2)"
          >
            级别
          </div>
          <div
            class="category-btn"
            :class="{ active: categoryType === 3 }"
            @click="selectCategoryType(3)"
          >
            项目分类
          </div>
        </div>

        <div
          class="form-fields"
          style="margin-top: 20px;"
        >
          <div class="form-item">
            <label>姓名</label>
            <el-input
              v-model="form.name"
              placeholder="请输入你的姓名"
            />
          </div>

          <div class="form-item">
            <label>电话号码</label>
            <el-input
              v-model="form.phone"
              placeholder="请输入你的电话号码"
            />
          </div>

          <!-- <div class="form-item">
            <label>验证码</label>
            <div class="code-input-wrapper">
              <el-input
                v-model="individualForm.code"
                placeholder="请输入你的验证码"
              />
              <el-button
                type="text"
                class="code-btn"
                :disabled="codeCountdown > 0"
                @click="sendCode"
              >
                {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
              </el-button>
            </div>
          </div> -->

          <div class="form-item">
            <label>专业领域</label>
            <el-select
              v-model="form.professional_field"
              placeholder="请选择你的专业领域"
              class="field-select"
            >
              <el-option
                v-for="field in professionalFields"
                :key="field.value || field.id"
                :label="field.label || field.name"
                :value="field.value || field.id"
              />
            </el-select>
          </div>

          <div class="form-item">
            <label>身份证正反面</label>
            <div class="upload-area">
              <div class="upload-item">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('id_card_front')"
                >
                  <img
                    v-if="previewImages.id_card_front"
                    :src="previewImages.id_card_front"
                    alt="身份证正面"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-camera-solid" />
                    <div class="upload-text">上传身份证正面</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_id_card_front"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'id_card_front')"
                >
              </div>
              <div class="upload-item">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('id_card_back')"
                >
                  <img
                    v-if="previewImages.id_card_back"
                    :src="previewImages.id_card_back"
                    alt="身份证反面"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-camera-solid" />
                    <div class="upload-text">上传身份证反面</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_id_card_back"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'id_card_back')"
                >
              </div>
            </div>
          </div>

          <div class="form-item">
            <label>资格证书上传</label>
            <div class="upload-area">
              <div class="upload-item large">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('qualification_cert')"
                >
                  <img
                    v-if="previewImages.qualification_cert"
                    :src="previewImages.qualification_cert"
                    alt="资格证书"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-document" />
                    <div class="upload-text">上传资格证书</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_qualification_cert"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'qualification_cert')"
                >
              </div>
            </div>
          </div>

          <!-- <div class="form-item">
            <label>其他联系方式(非必填)</label>
            <el-input
              v-model="individualForm.otherContact"
              placeholder="请输入其他联系方式"
            />
          </div> -->
        </div>
      </div>

      <!-- 企业注册表单 -->
      <div
        v-if="entryType === 2"
        class="form-section"
      >
        <div class="form-fields">
          <div class="form-item">
            <label>身份证正反面</label>
            <div class="upload-area">
              <div class="upload-item">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('id_card_front')"
                >
                  <img
                    v-if="previewImages.id_card_front"
                    :src="previewImages.id_card_front"
                    alt="身份证正面"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-camera-solid" />
                    <div class="upload-text">上传身份证正面</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_id_card_front"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'id_card_front')"
                >
              </div>
              <div class="upload-item">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('id_card_back')"
                >
                  <img
                    v-if="previewImages.id_card_back"
                    :src="previewImages.id_card_back"
                    alt="身份证反面"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-camera-solid" />
                    <div class="upload-text">上传身份证反面</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_id_card_back"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'id_card_back')"
                >
              </div>
            </div>
          </div>

          <div class="form-item">
            <label>资格证书上传</label>
            <div class="upload-area">
              <div class="upload-item large">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('qualification_cert')"
                >
                  <img
                    v-if="previewImages.qualification_cert"
                    :src="previewImages.qualification_cert"
                    alt="资格证书"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-document" />
                    <div class="upload-text">上传资格证书</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_qualification_cert"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'qualification_cert')"
                >
              </div>
            </div>
          </div>

          <div class="form-item">
            <label>营业执照上传</label>
            <div class="upload-area">
              <div class="upload-item large">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('business_license')"
                >
                  <img
                    v-if="previewImages.business_license"
                    :src="previewImages.business_license"
                    alt="营业执照"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-office-building" />
                    <div class="upload-text">上传营业执照</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_business_license"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'business_license')"
                >
              </div>
            </div>
          </div>

          <div class="form-item">
            <label>电话号码</label>
            <el-input
              v-model="form.phone"
              placeholder="请输入你的电话号码"
            />
          </div>

          <!-- <div class="form-item">
            <label>验证码</label>
            <div class="code-input-wrapper">
              <el-input
                v-model="enterpriseForm.code"
                placeholder="请输入你的验证码"
              />
              <el-button
                type="text"
                class="code-btn"
                :disabled="codeCountdown > 0"
                @click="sendCode"
              >
                {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
              </el-button>
            </div>
          </div> -->

          <!-- <div class="form-item">
            <label>其他联系方式(非必填)</label>
            <el-input
              v-model="enterpriseForm.otherContact"
              placeholder="请输入其他联系方式"
            />
          </div> -->
        </div>
      </div>

      <!-- 注册按钮 -->
      <div class="submit-section">
        <el-button
          type="primary"
          class="submit-btn"
          :loading="loading"
          @click="handleSubmit"
        >
          提交
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { submitCostEngineerInfo, getProfessionalFields, getCategoryOptions, uploadImage } from '@/api/user'
import { removeToken } from '@/utils/auth'

export default {
  name: 'Engineer',
  data() {
    return {
      entryType: 1, // 1个人 2企业
      categoryType: 1, // 1国内/国际 2级别 3项目分类
      codeCountdown: 0,
      loading: false,
      uploading: false, // 上传状态
      professionalFields: [], // 专业领域选项
      categoryOptions: [], // 分类选项
      previewImages: {
        id_card_front: '',
        id_card_back: '',
        qualification_cert: '',
        business_license: ''
      },
      form: {
        name: '', // 姓名
        phone: '', // 手机号
        id_card_front: '', // 身份证正面
        id_card_back: '', // 身份证反面
        qualification_cert: '', // 资格证书
        professional_field: '', // 专业领域
        entry_type: 1, // 1个人 2企业
        category_type: 1, // 1国内/国际 2级别 3项目分类
        business_license: '' // 营业执照（企业用）
      }
    }
  },
  mounted() {
    // 页面加载时获取专业领域和分类选项
    this.loadProfessionalFields()
    this.loadCategoryOptions()
  },
  methods: {
    // 获取专业领域
    async loadProfessionalFields() {
      try {
        const response = await getProfessionalFields()
        if (response.code === 1) {
          this.professionalFields = response.data || []
        }
      } catch (error) {
        console.error('获取专业领域失败:', error)
      }
    },
    // 获取分类选项
    async loadCategoryOptions() {
      try {
        const response = await getCategoryOptions()
        if (response.code === 1) {
          this.categoryOptions = response.data || []
        }
      } catch (error) {
        console.error('获取分类选项失败:', error)
      }
    },
    // 选择入口类型
    selectEntryType(type) {
      this.entryType = type
      this.form.entry_type = type
    },
    // 选择分类类型
    selectCategoryType(type) {
      this.categoryType = type
      this.form.category_type = type
    },
    // 处理图片上传
    handleImageUpload(event, fieldName) {
      const file = event.target.files[0]
      if (!file) return

      // 验证文件类型
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
      if (!allowedTypes.includes(file.type)) {
        this.$message.error('只支持 JPG、JPEG、PNG 格式的图片')
        return
      }

      // 验证文件大小（5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过 5MB')
        return
      }

      this.uploadImageFile(file, fieldName)
    },
    // 上传图片文件
    async uploadImageFile(file, fieldName) {
      this.uploading = true
      try {
        const response = await uploadImage(file)
        if (response.code === 1) {
          // 保存图片URL到表单数据
          this.form[fieldName] = response.data.url || response.data
          // 保存预览图片
          this.previewImages[fieldName] = URL.createObjectURL(file)
          this.$message.success('图片上传成功')
        } else {
          this.$message.error(response.msg || '图片上传失败')
        }
      } catch (error) {
        console.error('图片上传失败:', error)
        this.$message.error('图片上传失败，请重试')
      } finally {
        this.uploading = false
      }
    },
    // 触发文件选择
    triggerFileInput(fieldName) {
      this.$refs[`fileInput_${fieldName}`].click()
    },
    sendCode() {
      if (this.codeCountdown > 0) return

      const phone = this.entryType === 'individual'
        ? this.individualForm.phone
        : this.enterpriseForm.phone

      if (!phone) {
        this.$message.error('请先输入电话号码')
        return
      }

      this.codeCountdown = 60
      const timer = setInterval(() => {
        this.codeCountdown--
        if (this.codeCountdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)

      this.$message.success('验证码已发送')
    },
    async handleSubmit() {
      // 表单验证
      if (!this.validateForm()) {
        return
      }

      this.loading = true

      try {
        const response = await submitCostEngineerInfo(this.form)
        if (response.code === 1) {
          this.$message.success('注册提交成功')
          // 注册成功后删除token并返回登录页
          removeToken()
          setTimeout(() => {
            this.$router.push('/login')
          }, 1500) // 1.5秒后跳转，让用户看到成功提示
        } else {
          this.$message.error(response.msg || '提交失败')
        }
      } catch (error) {
        console.error('提交造价师信息失败:', error)
        this.$message.error('提交失败，请重试')
      } finally {
        this.loading = false
      }
    },
    // 表单验证
    validateForm() {
      const { name, phone, professional_field } = this.form

      if (!name) {
        this.$message.error('请输入姓名')
        return false
      }

      if (!phone) {
        this.$message.error('请输入手机号')
        return false
      }

      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.error('请输入正确的手机号')
        return false
      }

      if (!professional_field) {
        this.$message.error('请选择专业领域')
        return false
      }

      // 文件上传验证
      if (!this.form.id_card_front || !this.form.id_card_back) {
        this.$message.error('请上传身份证正反面')
        return false
      }

      if (!this.form.qualification_cert) {
        this.$message.error('请上传资格证书')
        return false
      }

      // 企业类型需要营业执照
      if (this.entryType === 2 && !this.form.business_license) {
        this.$message.error('请上传营业执照')
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.engineer-container {
  min-height: 100vh;
  width: 100%;
  background: url('~@/assets/image/bg3.png') center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  box-sizing: border-box;
}

.content-wrapper {
  background: #fff;
  border-radius: 20px;
  padding: 40px;
  width: var(--page-inner-ratio, 80%);
  max-width: 800px;
  max-height: calc(100vh - var(--navbar-total-height, 80px) - 40px);
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);

  @supports (height: 100dvh) {
    max-height: calc(100dvh - var(--navbar-total-height, 80px) - 40px);
  }

  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  .page-title {
    font-size: 28px;
    font-weight: 600;
    color: #111111;
  }

  .page-title-line{
	width: 120px;
	height: 5px;
	background: #0F6FE2;
	border-radius: 3px;
	position: absolute;
	left: 50%;
	bottom: -10px;
	transform: translateX(-50%);
  }

  .form-section {
    margin-bottom: 30px;

    .section-label {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin-bottom: 15px;
    }

    .entry-buttons,
    .category-buttons {
      display: flex;
      gap: 15px;

      .entry-btn,
      .category-btn {
        flex: 1;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 2px solid transparent;

        &.active {
          background: #0f6fe2;
          color: #fff;
          border-color: #0f6fe2;
        }

        &:not(.active) {
          background: #ecf2ff;
          color: #666;
          border-color: #ecf2ff;

          &:hover {
            background: #e8e8e8;
            border-color: #0f6fe2;
            color: #0f6fe2;
          }
        }
      }
    }

    .form-fields {
      .form-item {
        margin-bottom: 20px;

        label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin-bottom: 8px;
        }

        .el-input {
          width: 100%;
        }

        .code-input-wrapper {
          display: flex;
          gap: 10px;

          .el-input {
            flex: 1;
          }

          .code-btn {
            color: #0f6fe2;
            font-weight: 500;
            white-space: nowrap;
          }
        }

        .field-select {
          width: 100%;
        }

        .upload-area {
          display: flex;
          gap: 15px;

          .upload-item {
            flex: 1;

            &.large {
              flex: 2;
            }

            .upload-placeholder {
              height: 120px;
              border: 2px dashed #d9d9d9;
              border-radius: 8px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.3s ease;
              position: relative;
              overflow: hidden;

              &:hover {
                border-color: #0f6fe2;
                background: #f0f8ff;
              }

              &.uploading {
                border-color: #0f6fe2;
                background: #f0f8ff;
                cursor: not-allowed;
              }

              .upload-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                i {
                  font-size: 24px;
                  color: #999;
                  margin-bottom: 8px;
                }

                .upload-text {
                  font-size: 12px;
                  color: #999;
                }
              }

              .preview-img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 6px;
              }

              .upload-loading {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(255, 255, 255, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;

                i {
                  font-size: 20px;
                  color: #0f6fe2;
                }
              }
            }

            .id-card-img {
              width: 100%;
              object-fit: cover;
              border-radius: 8px;
              transition: all 0.3s ease;

              &:hover {
                transform: scale(1.02);
              }
            }

            .certificate-img {
              width: 50%;
              object-fit: cover;
              border-radius: 8px;
              transition: all 0.3s ease;

              &:hover {
                transform: scale(1.02);
              }
            }
          }
        }
      }
    }
  }

  .submit-section {
    text-align: center;
    margin-top: 40px;

    .submit-btn {
      width: 100%;
      height: 50px;
      font-size: 18px;
      font-weight: 600;
      background: #0f6fe2;
      border: none;
      border-radius: 8px;

      &:hover {
        background: #0c5bc7;
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(15, 111, 226, 0.3);
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .engineer-container {
    padding: 60px 20px;
  }

  .content-wrapper {
    padding: 30px 20px;

    .page-title {
      font-size: 24px;
      margin-bottom: 30px;
    }

    .form-section {
      .entry-buttons,
      .category-buttons {
        flex-direction: column;
        gap: 10px;

        .entry-btn,
        .category-btn {
          height: 45px;
          font-size: 14px;
        }
      }

      .form-fields {
        .form-item {
          .upload-area {
            flex-direction: column;
            gap: 10px;

            .upload-item {
              .upload-placeholder {
                height: 100px;
              }
            }
          }
        }
      }
    }

    .submit-section {
      .submit-btn {
        width: 100%;
      }
    }
  }
}
</style>
